module.exports = __webpack_public_path__ + "img/haveUser.6c41f80d.png";